/**
 * Prefer the server-returned S3 object key for CollectionOnboarding.
 * Falls back to the local filename when the process response omits a key.
 */
export function resolveUploadedObjectKey(
  returnedKey: string | null | undefined,
  fallbackFileName: string,
): string {
  const key = returnedKey?.trim();
  if (key) {
    return key;
  }
  return fallbackFileName.trim();
}
